"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <Header />
      <main>
        <section className="my-10 mx-auto px-6 max-w-[673px]">
          <div className="py-20 text-center">
            <h1 className="font-assistant text-4xl text-slate-200 mb-6">
              Something went wrong
            </h1>
            <p className="text-slate-300 mb-8">
              We apologize for the inconvenience. An error has occurred while
              loading this page.
            </p>
            <button
              onClick={reset}
              className="rounded-full bg-brand-solid px-6 py-2.5 text-sm font-normal text-white shadow-sm hover:bg-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-hover"
            >
              Try again
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
